import { AppLink } from './AppLink.js';
import type { Route } from '../lib/router.js';

interface AppHeaderProps {
  route: Route;
  onNavigate: (path: string) => void;
}

const LINKS: { path: string; label: string; match: Route['name'][] }[] = [
  { path: '/', label: 'Главная', match: ['home'] },
  { path: '/new', label: 'Создать', match: ['new'] },
  { path: '/rooms', label: 'Открытые', match: ['rooms'] },
  { path: '/profile', label: 'Профиль', match: ['profile'] },
];

/**
 * Шапка сайта.
 *
 * Липкая и полупрозрачная: при прокрутке под ней просвечивает страница,
 * поэтому граница между шапкой и содержимым остаётся видимой без тяжёлой
 * тени. В комнате своя шапка — там места под навигацию нет.
 */
export function AppHeader({ route, onNavigate }: AppHeaderProps): JSX.Element {
  return (
    <header className="app-header">
      <div className="app-header__inner">
        <AppLink className="app-header__brand" href="/" onNavigate={onNavigate}>
          <span className="app-header__mark" aria-hidden="true" />
          <span>Смотрим вместе</span>
        </AppLink>

        <nav className="app-header__nav" aria-label="Разделы сайта">
          {LINKS.map((link) => {
            const active = link.match.includes(route.name);
            return (
              <AppLink
                key={link.path}
                href={link.path}
                onNavigate={onNavigate}
                className={`app-tab ${active ? 'app-tab--active' : ''}`}
                aria-current={active ? 'page' : undefined}
              >
                {link.label}
              </AppLink>
            );
          })}
        </nav>
      </div>
    </header>
  );
}
